module.exports = __webpack_public_path__ + "img/6.49fcd8d4.jpg";